import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { VehiclePurchaseType } from "../../types/Quote";
import { State } from "../../types/State";

type CreateQuotePayload = {
  purchaseType: VehiclePurchaseType;
  state: State;
  variantId: string;
  term: number;
  annualKilometres: number;
  salary: number;
  businessUsage: number;
  discount: number;
  initialOdometer: number;
  listPrice?: number;
  referralCode?: string;
  aiQueryId?: string;
  vehicleReviewAIQueryId?: string;
  vehicleSearchEventId?: string;
};

export const createQuote = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();

  return useMutation({
    mutationFn: (payload: CreateQuotePayload): Promise<string> => {
      return fetchWithAuth<string>("createQuote", dossierId, {
        requestOptions: { method: "post", body: JSON.stringify(payload) },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () =>
      defaultOnMutateSettled([
        ["quotes", dossierId],
        ["dossier", dossierId],
      ]),
  });
};
